import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import Select from "react-select";

const UserDetails = ({ isLoading, isError, tenants, onFormChange, formData }) => {
  const tenantOptions = tenants?.map((tenant) => ({
    value: tenant.id,
    label: tenant.name
  }));

  const handleFieldChange = (e) => {
    const { id, value } = e.target;
    onFormChange(id, value);
  };

  const handleTenantChange = (selectedOption) => {
    onFormChange("tenantId", selectedOption?.value || "");
    onFormChange("tenantName", selectedOption?.label || "");
  };

  return (
    <div className="member-section mb-5 p-4 bg-light border rounded">
      <h5 className="text-white p-2" style={{ backgroundColor: "#243544" }}>
        Details
      </h5>
      <Row>
        <Col md={6}>
          <Form.Group controlId="firstName" className="mb-4">
            <Form.Label>First Name</Form.Label>
            <Form.Control type="text" placeholder="Enter First Name" value={formData.firstName} onChange={handleFieldChange} required />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group controlId="lastName" className="mb-4">
            <Form.Label>Last Name</Form.Label>
            <Form.Control type="text" placeholder="Enter Last Name" value={formData.lastName} onChange={handleFieldChange} required />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group controlId="email" className="mb-4">
            <Form.Label>Email</Form.Label>
            <Form.Control type="email" placeholder="Enter Email" value={formData.email} onChange={handleFieldChange} required />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group controlId="roleName" className="mb-4">
            <Form.Label>Role</Form.Label>
            <Form.Control as="select" value={formData.roleName} onChange={handleFieldChange} required>
              <option value="">Select Role</option>
              <option value="Admin">Admin</option>
              <option value="Editor">Editor</option>
              <option value="Viewer">Viewer</option>
              <option value="Scenario">Scenario</option>
              <option value="Envana_Admin">Envana_Admin</option>
              <option value="EnvanaTrial">EnvanaTrial</option>
            </Form.Control>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group controlId="tenantId" className="mb-4" required>
            <Form.Label>
              Tenant <span className="text-danger">*</span>
            </Form.Label>
            {isLoading && <p>Loading tenants...</p>}
            {isError && <p className="text-danger">Failed to load tenants.</p>}
            {!isLoading && !isError && (
              <Select
                options={tenantOptions}
                onChange={handleTenantChange}
                value={tenantOptions?.find((option) => option.value === formData.tenantId) || null}
                placeholder="Search and select a tenant (required)"
                isClearable
                isSearchable
              />
            )}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group controlId="gcpMemberId" className="mb-4">
            <Form.Label>GCP Member ID</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter GCP Member ID (optional)"
              value={formData.gcpMemberId || ""}
              onChange={handleFieldChange}
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default UserDetails;
